import { fetchApi } from '@/config/axiosSetting';
import { DeleteDamagedAdjusterDocumentImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteDamagedAdjusterDocumentImages/deleteDamagedAdjusterDocumentImagesQuery.type';

export const deleteDamagedAdjusterDocumentImagesFunction = (
  params: DeleteDamagedAdjusterDocumentImagesQueryParamsType,
) => {
  const data = new FormData();
  data.append('image_id', params.data.image_id);

  const generateUrl = () => {
    switch (params.type) {
      case 'damaged':
        return `/property/reports/${params.id}/accident_users/damaged/images/adjuster/document/`;

      case 'body':
        return `/body/reports/${params.id}/images/adjuster/document/`;

      case 'culprit':
        return `/property/reports/${params.id}/accident_users/culprit/images/adjuster/document/`;

      case 'initial':
        return `/initial/reports/${params?.id}/images/adjuster/document/`;
    }
  };

  return fetchApi({
    method: 'DELETE',
    url: generateUrl(),
    data,
    params:
      params.type === 'damaged' ? { damaged_id: params?.damagedId } : undefined,
  });
};
